<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-create-service`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24 2c12.15 0 22 9.85 22 22 0 .674-.03 1.342-.09 2h-4.02c.073-.656.11-1.324.11-2 0-9.941-8.059-18-18-18S6 14.059 6 24s8.059 18 18 18c.676 0 1.344-.037 2-.11v4.02c-.658.06-1.326.09-2 .09-12.15 0-22-9.85-22-22S11.85 2 24 2zm9.165 27.552c.332-.535 1.055-.712 1.614-.394l10.644 6.055c.24.136.421.35.512.601.212.589-.113 1.231-.728 1.435l-3.771 1.249 3.072 5.096c.325.54.132 1.23-.43 1.54l-1.292.715c-.563.311-1.283.126-1.608-.413l-3.073-5.096-3.013 2.5c-.21.176-.48.273-.758.276-.65.008-1.183-.492-1.191-1.114L33 30.14a1.1 1.1 0 01.165-.589zM26 15a1 1 0 00-1-1h-2a1 1 0 00-1 1v7h-7a1 1 0 00-1 1v2a1 1 0 001 1h7v7a1 1 0 001 1h2a1 1 0 001-1v-7h7a1 1 0 001-1v-2a1 1 0 00-1-1h-7v-7z"/></svg>
</template>
<script>

export default {
  name: 'IconCreateService',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
